import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDateRangeCol,
  createDetailButtonColV2,
  createIdCol,
  createNumberCol,
  createTypoCol,
  createViewableCol,
} from '@/src/helpers/agColumnHelper';
import { OPTIONS_CONST } from '@/src/constants/options';

export const recyclingCouponListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createTypoCol({
    field: 'sponsorName',
    size: 'lg',
    headerName: '후원사 명',
  }),
  createDateRangeCol({
    field: 'postedAt',
    keys: ['onAt', 'offAt'],
    headerName: '게시 기간',
  }),
  createNumberCol({
    field: 'usedCouponCnt',
    size: 'sm',
    headerName: '사용 수',
  }),
  createViewableCol({
    field: 'isExposed',
    size: 'sm',
    headerName: '노출 여부',
  }),
  createCustomCol({
    field: 'exposeService',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data.exposeService === 'APP'
        ? OPTIONS_CONST.onlyApp
        : OPTIONS_CONST.onlyWeb,
    headerName: '노출 범위',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];
